/* RESPONSIBLE TEAM: team-ai-agent */
import ContentController from 'embercom/controllers/apps/app/automation/fin-ai-agent/content';

export default class SalesContentController extends ContentController {}
